{{ message }}

<div class="flex-center-row control-header">
  <div class="spacer"></div>
  <button busy-button [busy]="acknowledgingIssue" class="arpio-button" (click)="acknowledgeIssue()">Acknowledge</button>
</div>
